import React from "react";

function StatusDot({ color = "#ccc" }) {
  const style = {
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    display: "block",
  };

  return <span style={{ ...style, backgroundColor: color }}></span>;
}

export default StatusDot;
